<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import { Button, Col, FormGroup, Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Popover, Row } from "sveltestrap";
    import type { Complainant } from "../Model/Complainant";
    import type { Third } from "../Model/Third";
	import { fileServices, paramsService, procedencesService, recordsExternalBackgroundService, thirdsService, usersService, writeFileService } from "../services";
    import { dateInputFormatter, dateTimeInputFormatter } from "../services/Functions";
    import AddThirdList from "./AddThirdList.svelte";
    import ThirdNameInput from "./ThirdNameInput.svelte";
	import type { RegisterExternalBackground } from "../Model/RegisterExternalBackground";
    import type { User } from "../Model/User";
    import AntecedentSelect from "./antecedentSelect.svelte";
    import ProcedenceAntecedentSelect from "./procedenceAntecedentSelect.svelte";
    import { REGISTERSEXTERNALANTECEDENTS } from "../evironment";

	const dispatch = createEventDispatcher();

	let size = 'lg';
	let open = false;
	let changeThird = false;
	let third: Third;
	let users: User[];
	let buttonOut = true;
	let buttonIn = true;
	let deleteIn, deleteOut = false;
	let currentUser: User;

	let date: string;
	let time: string;
	let offset: number = 0;
  	let limit: number = 179;
  	let searchFilter = null;
	let files: any[] = [];
	let pop = false;
	const delay = (ms: any | undefined) => new Promise(res => setTimeout(res, ms));

	$: loadUsers();
	$: user();

	export let register: RegisterExternalBackground = null;
	export let newRegister: boolean = false;

	$: open = !!register; 

	const toggle = () => {
	  size = 'lg';
	  open = !open;
	};

	async function user() {
		currentUser = await usersService.findActualUser();
	}

	async function save(){

		const response = await saveRegister();

		if(response){
			open = false;
			dispatch("registerUpdate", register);
		}
	}

	async function saveRegister(){
		return await recordsExternalBackgroundService.saveRegisters(register);
	}

	async function loadUsers() {
    let opts = {
      offset: offset,
      limit: limit,
      filters: {
        search: searchFilter,
      },
    };
    try {
      users = await usersService.findUsers(opts);
    } catch (err) {}
  }

	async function changeThirdEvent(third){
		console.log(third)
    	register.thirdId = third.id;
		register.thirdName = third.name
    	changeThird = false;
    	dispatch("changeThirdLIst", third);
  	}

	  async function generateDate(type:string, visibility:boolean) {
		if (type == 'in') {
			let inDate = document.querySelector('#inDate');
			
			if (visibility) {
				inDate.disabled = visibility;
				buttonIn = visibility;
				deleteIn = false;

				register.dateCreated = null;
			} else {
				inDate.disabled = visibility;
				buttonIn = visibility;
			 	deleteIn = true;

				register.dateCreated = new Date();
			}
		} else if (type == 'out') {
			let outDate = document.querySelector('#outDate');
			
			if (visibility) {
				outDate.disabled = visibility;
				buttonOut = visibility;
				deleteOut = false;

				register.deadlineDate = null;
			} else {
				outDate.disabled = visibility;
				buttonOut = visibility;
			 	deleteOut = true;

				register.deadlineDate = new Date();
			}
		}
	}

	async function download(fileId) {
		try {
			await writeFileService.writeAntecedentFile(register, fileId)
		} catch(error) {
			console.log(error)
		}
	}

	async function chooseFile() {
		try {
			files = await fileServices.findFilesByContext(REGISTERSEXTERNALANTECEDENTS);
		} catch(error) {

		}
	}

</script>

  
	<Modal isOpen={open} {toggle} {size}>
	  <ModalHeader {toggle}>Editar Registro</ModalHeader>
	  <ModalBody>
			<Row>
                <Col xs="4">
					<FormGroup>
						<Label for="exampleEmail">Fecha</Label>
						<Input
							id='inDate'
							disabled
                            type="date"
                            value={dateInputFormatter(register.dateCreated)}  
                            on:change={(event)=>register.dateCreated = event.currentTarget.value}
						/>
					</FormGroup>
                </Col>
				{#if currentUser.type.id == 4 || currentUser.type.id == 3 || newRegister}
					<Col xs="1">
						<FormGroup>
							{#if buttonIn}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateDate('in',false)}>
									<Icon name='pencil' />
								</Button>
							{/if}
							{#if deleteIn}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateDate('in',true)}>
									<Icon name='x-lg' />
								</Button>
							{/if}
						</FormGroup>
					</Col>
				{/if}
                <Col xs="4">
                    <FormGroup>
						<Label for="exampleEmail">Fecha final</Label>
						<Input
							id='outDate'
							disabled
						    type="date"
                            value={dateInputFormatter(register.deadlineDate)}  
                            on:change={(event)=>register.deadlineDate = event.currentTarget.value}
						/>
					</FormGroup>
                </Col>
				{#if currentUser.type.id == 4 || currentUser.type.id == 3 || newRegister}
					<Col xs="1">
						<FormGroup>
							{#if buttonOut}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateDate('out',false)}>
									<Icon name='pencil' />
								</Button>
							{/if}
							{#if deleteOut}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateDate('out',true)}>
									<Icon name='x-lg' />
								</Button>
							{/if}
						</FormGroup>
					</Col>
				{/if}
                <Col xs="6">
                    <FormGroup>
						<Label for="exampleEmail">Procedencia</Label>
						<ProcedenceAntecedentSelect bind:procedenceAntecedentSelectId={register.origin} bind:procedenceAntecedentSelectName={register.originName} />
					</FormGroup>
                </Col>
                <Col xs="8">
                    <FormGroup>
						<Label for="exampleEmail">Tercero</Label>
						<div class="input-group">
							<ThirdNameInput id={register.thirdId} />
							<button
								class="btn btn-secondary"
								type="button"
								id="complainantThirId"
								name="complainantThirId"
								on:click={() => {if(changeThird){changeThird = false} else {changeThird = true}}}
							>
								<Icon name="plus" />
							</button>
						</div>

						{#if changeThird}
							<div class="m-3 p-2 border rounded third-box-modal">
								<h5>Busqueda de Terceros</h5>
          						<AddThirdList on:changeThird={(event) => changeThirdEvent(event.detail)} />
								<div class='text-end mt-2'>
									<a href="/tercero/new" class='btn btn-success text-white text-decoration-none' target='_blank'>Crear tercero</a>
								</div>
							</div>
						{/if}
					</FormGroup>
                </Col>
                <Col xs="12">
                    <FormGroup>
						<Label for="exampleEmail">Antecedence</Label>
						<AntecedentSelect bind:antecedentSelectId={register.antecedentType} bind:antecedentSelectName={register.antecedentTypeName} />
					</FormGroup>
                </Col>
			</Row>

	  </ModalBody>
	  	<ModalFooter>
			<Button color='success' id="btnDismissible" on:click={() => {chooseFile(); pop == false ? pop = true : pop = false}}>Descargar documento</Button>
			{#if pop}
					<div class='pop bg-white shadow-lg rounded-3 border border-1' >
						<div class='bg-light p-2 border- border-bottom'>
							Seleccione un fichero
						</div>
						<div class='p-4 d-flex flex-column'>
							{#if files.length > 0}
								{#each files as file}
									<button class='btn btn-secondary mb-2 fs-6' on:click={async() => {download(file.id); await delay(500).then(() => pop = false) }}>{file.name}</button>
								{/each}
							{:else}
								<span>No hay ficheros para descargar</span>
							{/if}
						</div>
					</div>
				{/if}
			<Button color="primary" on:click={save}>Guardar</Button>
	  	</ModalFooter>
	</Modal>

	<style>
		.pop {
			position: absolute;
			bottom: 60px;
			right: 100px;
			width: auto;
		}
	</style>